import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { QrCode } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  useEffect(() => { document.title = "Page not found — CiteQR"; }, []);
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center px-4 text-center fade-in">
      <div className="flex h-16 w-16 items-center justify-center rounded-xl bg-slate-100"><QrCode className="h-8 w-8 text-[#0A2540]" /></div>
      <p className="mt-6 text-sm font-semibold text-[#0D9488]">404</p>
      <h1 className="mt-2 text-3xl font-bold tracking-tight text-slate-900">Page not found</h1>
      <p className="mt-3 max-w-md text-base text-slate-600">The page you're looking for doesn't exist or may have been moved.</p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Button asChild className="bg-[#0D9488] text-white hover:bg-[#0F766E]"><Link to="/">Go home</Link></Button>
        <Button asChild variant="outline"><Link to="/generator">Create a QR code</Link></Button>
      </div>
    </div>
  );
}
